import { useContext, useEffect, useMemo, useState } from 'react';

import { useListCitiesByEntryQuery } from '@app/api/DaData';
import { FRONT_WARNING } from '@app/constants';
import type { AutoCompleteCityOption } from '@app/pages/Registration/Registration.types';
import { NotificationContext } from '@app/providers';

export const useCitiesAutocomplete = () => {
  const [selectedCityId, setSelectedCityId] = useState<string | null>(null);
  const [city, setCity] = useState<string>('');

  const { showNotification } = useContext(NotificationContext);
  const changeCity = (value: string) => {
    setCity(value);
  };
  const selectCity = (_value: string, option: AutoCompleteCityOption) => {
    setSelectedCityId(option.id);
  };

  const { data: citiesData, error: getCitiesError } = useListCitiesByEntryQuery(
    {
      searchStr: city,
    },
    {
      skip: !city,
    }
  );

  useEffect(() => {
    if (getCitiesError) {
      let errorMessage = 'Произошла ошибка при загрузке данных о городах';

      if ('data' in getCitiesError) errorMessage = `${getCitiesError.data}`;

      showNotification(errorMessage, FRONT_WARNING);
    }
  }, [getCitiesError, showNotification]);

  const cities = useMemo(() => {
    return citiesData
      ? citiesData.map(({ Id, Region, City }) => {
          const cityName = City ?? '';

          return {
            value: cityName,
            label: Region ? `${cityName} (${Region})` : cityName,
            id: Id,
          };
        })
      : [];
  }, [citiesData]);

  return {
    cities,
    selectedCityId,
    changeCity,
    selectCity,
  };
};
